<template>
  <div>
    <SGPRowComponent>
      <div class="p-4">
        <h4> Digite a OS SAP</h4>
        <form @submit.prevent="submit()">
          <SGPFormInputComponent name="osSapWeb" type="text" placeholder="OS SAP" v-model="formulario.osSapWeb" />
          <br>
          <SGPFormBotaoComponent type="submit" color="primary" block rounded middle >
          <span>Consultar</span>
        </SGPFormBotaoComponent>
        </form>
  
        <!-- Display the retorno -->
        <div class="sapweb-geral" v-if="retorno">
          <div class="sapweb-dados" >
            <strong>Numero OS Sap</strong><br>
            <pre> {{ retorno.numeroOSSap }}</pre>
          </div>
          <div class="sapweb-dados" >
            <strong>Status OS</strong><br>
            <pre> {{ retorno.statusOS }}</pre>
          </div>
          <div class="sapweb-dados" >
            <strong>Descrição</strong><br>
            <pre> {{ retorno.descricao }}</pre>
          </div>
          <div class="sapweb-dados" >
            <strong>Modelo Equipamento</strong><br>
            <pre> {{ retorno.modeloEquipamento }}</pre>
          </div>
          <div class="sapweb-dados" >
            <strong>Local de Entrega Descarga</strong><br>
            <pre> {{ retorno.localEntregaDescarga }}</pre>
          </div>
          <div class="sapweb-dados" >
            <strong>Dados do contato</strong><br>
            <pre> {{ retorno.dadosContato }}</pre>
          </div>
        </div>
      </div>
    </SGPRowComponent>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
name: 'ModalConsultaAutomacaoComponent',
components: {
  
},
props:{
  value: {
    type: Boolean,
    required: true,
    default: false
  },
},
data () {
  return {    
      submitForm: false,
      formulario: {
          designacao: '',
          osSapWeb: ''
      },
      retorno:null,
      ossap: [
      { status: 'ENEB', descricao: 'Entrega concluída' },
      { status: 'PEND', descricao: 'Pendente' },
      { status: 'ACEI', descricao: 'Aceita OPR' },
      { status: 'CRIA', descricao: 'Criada' },
      { status: 'BAES', descricao: 'Baixado do estoque' },
      { status: 'EXPE', descricao: 'CPE conf. out' },
      { status: 'CPCO', descricao: 'CPE configurado' },
      { status: 'CPRE', descricao: 'CPE na sala conf.' },
      { status: 'REAB', descricao: 'Reserva aberta' },
    ]
    }
  },
mounted() {
  if (this.value) {
    this.formulario.osSapWeb = this.value.sapweb;
  }
},

methods: {
  ...mapActions('automacao', [
    'listarSAPWEB'
  ]),
  getDescricao(status) {
    const statusInfo = this.ossap.find(item => item.status === status);
    return statusInfo ? statusInfo.descricao : 'Sem descrição'; 
  },
  async submit() {
    this.submitForm = true;
    const payload = {
      designacao: '',
      osSapWeb: this.formulario.osSapWeb
    };
    
    try {
      console.log('sao dados do payload', payload)
      let response = await this.listarSAPWEB([payload]);
      if (response && response.data) {
          this.retorno = response.data;
          this.retorno.map(dados => {
          this.retorno.numeroOSSap = dados.numeroOSSap
          this.retorno.statusOS = dados.statusOS
          this.retorno.modeloEquipamento = dados.modeloEquipamento
          this.retorno.localEntregaDescarga = dados.localEntregaDescarga
          this.retorno.dadosContato = dados.dadosContato
          this.retorno.descricao = this.getDescricao(dados.statusOS);
        });
      } else {
        console.error('Erro ao obter dados:', response);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
    }
  },
}
}

</script>
<style>
.sapweb-geral {
  padding-top: 15px;
  margin-left: 10px;
}

.sapweb-dados {
  float: left;
  margin-bottom: 10px;
  width: calc(50% - 10px);
}
</style>